module.exports = __webpack_public_path__ + "public/images/secret.063a770e1c3f3ee6bae892a08b7f8e10.jpg";